module.exports = __webpack_public_path__ + "img/41_21.b753bc4f.png";